import { useCallback } from 'react';
import type { ISubscriptionPlanPrice } from 'services/rpc/subscriptionRpcService';
import { useSubscriptionRpc } from '..';

const ESSENTIAL_HANDLE_MATCH = 'essential';
const PRO_HANDLE_MATCH = 'pro';

export function useGetPrices() {
  const subscriptionRpc = useSubscriptionRpc();
  return useCallback(
    (): Promise<ISubscriptionPlanPrice[]> => subscriptionRpc.getPrices().then((res) => res.data.result ?? []),
    [subscriptionRpc]
  );
}

export function findEssentialPrice(
  plans: ISubscriptionPlanPrice[] | null | undefined
): ISubscriptionPlanPrice | undefined {
  return plans?.find((plan) => plan.productHandle.toLowerCase().includes(ESSENTIAL_HANDLE_MATCH));
}

export function findProPrice(plans: ISubscriptionPlanPrice[] | null | undefined): ISubscriptionPlanPrice | undefined {
  return plans?.find((plan) => plan.productHandle.toLowerCase().includes(PRO_HANDLE_MATCH));
}
